import useAppBootstrap from '@/hooks/useAppBootstrap';
import AppShell from '../AppShell';

/**
 * Top-level composition. All boot-time effects live behind useAppBootstrap;
 * all rendering lives in AppShell. The split keeps each layer focused on
 * one concern and makes the boot path independently testable.
 */
const AppContent = () => {
  const { isPending } = useAppBootstrap();

  if (isPending) return null;

  return <AppShell />;
};

export default AppContent;
